import React from 'react'
import CIcon from '@coreui/icons-react'
import { CLink } from '@coreui/react'
import memoizee from 'memoizee'
import { useHistory } from 'react-router-dom'
import { ModelApi } from 'src/api'
import { ActionButton } from 'src/views/buttons'
import { useToken } from 'src/state/ducks/auth/hooks'
import { useModalForm } from 'src/state/ducks/modalForm/hooks'

import NoDataImage from '../assets/no-data.svg'

// Helpers shared by DjangoList and LegacyDjangoList (re-exported by
// DjangoList.js, where the rest of the app imports them from)

export const isMobile = {
  Android: memoizee(() => navigator.userAgent.match(/Android/i)),
  BlackBerry: memoizee(() => navigator.userAgent.match(/BlackBerry/i)),
  iOS: memoizee(() => navigator.userAgent.match(/iPhone|iPad|iPod/i)),
  Opera: memoizee(() => navigator.userAgent.match(/Opera Mini/i)),
  Windows: memoizee(
    () =>
      navigator.userAgent.match(/IEMobile/i) ||
      navigator.userAgent.match(/WPDesktop/i)
  ),
  any: memoizee(
    () =>
      // TODO: Consider adding small resolutions on this too
      isMobile.Android() ||
      isMobile.BlackBerry() ||
      isMobile.iOS() ||
      isMobile.Opera() ||
      isMobile.Windows()
  ),
}

export const EmptyTableSlot = ({
  text = 'Sem resultados',
  showIllustration = false,
}) => (
  <div style={{ textAlign: 'center', opacity: '.5' }}>
    {showIllustration ? (
      <img
        src={NoDataImage}
        alt="no data"
        style={{ height: '6rem', margin: '1rem auto', display: 'block' }}
      />
    ) : (
      <CIcon name="cil-list" style={{ marginRight: '.2rem' }} />
    )}
    {text}
  </div>
)

export const parseReportFilterForm = (data, form) => {
  const dataForRequest = {}
  delete data.company
  Object.entries(data).forEach(([key, val]) => {
    if (!val) delete data[key]
    if (typeof val === 'boolean') data[key] = val ? 'True' : 'False'
  })
  Object.entries(form.fields).forEach(([key, val]) => {
    let value = data[key]
    if (!value) return
    if (val.model_name) dataForRequest[`${key}_id`] = value
    else dataForRequest[key] = value
  })
  return dataForRequest
}

export const FormButton = ({
  title,
  iconName,
  objectId,
  copyId,
  djangoApp,
  djangoModel,
  formRoute,
  onReload,
  formsAsModal,
  style,
  reloadOnClose = true,
}) => {
  const token = useToken()
  const showModalForm = useModalForm()
  const history = useHistory()

  if (formRoute && !formsAsModal)
    return (
      <ActionButton
        label={title}
        onClick={() => history.push(formRoute, { id: objectId })}
        iconName={iconName}
      />
    )
  else
    return (
      <>
        <CLink
          color="primary"
          onClick={async () => {
            const {
              data: { form = {} },
            } = await ModelApi.shared.form(
              token,
              djangoApp,
              djangoModel,
              copyId
            )
            const copyData = {
              ...(form.data || {}),
              id: undefined,
              custom_identifier: undefined,
            }

            showModalForm(
              objectId,
              djangoApp,
              djangoModel,
              copyData || {},
              {},
              onReload ? onReload : () => window.location.reload(),
              reloadOnClose
                ? onReload
                  ? onReload
                  : () => window.location.reload()
                : null
            )
          }}
          style={style}
        >
          <CIcon name={iconName} style={{ marginRight: '5px' }} />
          {!isMobile.any() && title}
        </CLink>
      </>
    )
}
